import {useState} from "react";

import {ComboboxGeneric} from "@/components/ui/combobox-generic";
import {getStorageItem} from "@/src/modules/core/lib";

import {IncidentReportType} from "../types";

type IncidentTypeComboboxProps = {
  value: IncidentReportType | null;
  onChange: (value: IncidentReportType | null) => void;
};

export function IncidentTypeCombobox({value, onChange}: IncidentTypeComboboxProps) {
  const [incidentReportTypes] = useState<IncidentReportType[]>(
    getStorageItem("incidentReportTypes"),
  );

  return (
    <ComboboxGeneric<IncidentReportType>
      items={incidentReportTypes}
      value={value}
      onChange={onChange}
      getItemKey={(item) => `incident-type-${item.incident_report_type_id}`}
      getItemLabel={(item) => item.type}
      isItemEqual={(item, selected) =>
        item.incident_report_type_id === selected?.incident_report_type_id
      }
      placeholder="Select type"
      emptyMessage="No items found."
    />
  );
}
